import React, { useState, useEffect } from "react";
import { Header } from "../Header";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, MenuItem, Select, FormControl, InputLabel, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { local_url } from "../Const";
import { useLocation } from 'react-router-dom';


export const CompanyList = () => {

  const navigate = useNavigate();

  const location = useLocation();
  const { companyName, companyCode } = location.state || {};
  const [places, setPlaces] = useState([]);
  const [loadingPlaces, setLoadingPlaces] = useState(false);
  const [ledgerData, setLedgerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dropdownValue, setDropdownValue] = useState("CUST");
  const [openForm, setOpenForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [formData, setFormData] = useState({
    entityCode: "",
    entityName: "",
    regAddress1: "",
    regAddress2: "",
    regAddress3: "",
    pinCode: "",
    placeCode: "",
    cityCode: "",
    stateCode: "",
    countryCode: "",
    entityType: "",
    entityGroupCode: "",
    deleted: "",
    logoPath: "",
    headerImagePath: "",
    configCountryCode: "",
    halfDayAllowed: false,
    currencyCode: "",
    webSite: "",
    createdUserCode: "",
    creditLimit: 0,
    creditDays: 0
  });



  const fetchLedgerData = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('AuthorizationToken');
      const response = await fetch(`${local_url}/api/Company/GetCompanyList`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setLedgerData(data);
    } catch (error) {
      setError("Failed to fetch company data. Please try again later.");
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLedgerData();
  }, []);

  const fetchPlacesByPincode = async (pincode) => {
    setLoadingPlaces(true);
    setError(null);
    try {
      const response = await fetch(
        `${local_url}/api/Place/${pincode}`
      );
      if (!response.ok) throw new Error("Failed to fetch places");
      const data = await response.json();
      setPlaces(data.places);
    } catch (error) {
      setError("Error fetching places");
      console.error(error);
    } finally {
      setLoadingPlaces(false);
    }
  };

  // Fetch place details by placeId
  // Fetch place details by placeId
  // Fetch place details by placeId
  const fetchPlaceDetailsById = async (placeId) => {
    try {
      const response = await fetch(
        `${local_url}/api/PlaceName/GetPlaceById/${placeId}`
      );
      if (!response.ok) throw new Error("Failed to fetch place details");
      const data = await response.json();
      if (data.length > 0) {
        const { stateCode, countryCode, cityId, stateName, cityName } = data[0];
        setFormData((prevFormData) => ({
          ...prevFormData,
          stateCode,      // Code to be sent in the request
          cityCode: cityId,  // Code to be sent in the request
          stateName,      // Name for display
          cityName,       // Name for display
          countryCode,
        }));
      }
    } catch (error) {
      setError("Error fetching place details");
      console.error(error);
    }
  };



  // Handle pincode change
  const handlePincodeChange = (e) => {
    const pincode = e.target.value;
    setFormData({ ...formData, pinCode: pincode });
    if (pincode.length === 6) {
      fetchPlacesByPincode(pincode);
    }
  };

  // Handle place selection
  const handlePlaceSelect = (e) => {
    const selectedPlaceId = e.target.value;
    setFormData({ ...formData, placeCode: selectedPlaceId });
    fetchPlaceDetailsById(selectedPlaceId);
  };

  // Handle form input change
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const handleOpenForm = () => {
    setIsEditing(false);
    setFormData({
      entityCode: "",
      entityName: "",
      regAddress1: "",
      regAddress2: "",
      regAddress3: "",
      pinCode: "",
      placeCode: "",
      cityCode: "",
      stateCode: "",
      countryCode: "",
      entityType: "",
      entityGroupCode: "",
      deleted: "",
      logoPath: "",
      headerImagePath: "",
      configCountryCode: "",
      halfDayAllowed: false,
      currencyCode: "",
      webSite: "",
      createdUserCode: "",
      creditLimit: 0,
      creditDays: 0
    });
    setOpenForm(true);
  };

  const handleEdit = (rowData, index) => {
    setIsEditing(true);
    setSelectedRowIndex(index);
    setFormData({
      entityCode: rowData.entityCode || "",
      entityName: rowData.entityName || "",
      regAddress1: rowData.regAddress1 || "",
      regAddress2: rowData.regAddress2 || "",
      regAddress3: rowData.regAddress3 || "",
      pinCode: rowData.pinCode || "",
      placeCode: rowData.placeCode || "",
      cityCode: rowData.cityCode || "",
      stateCode: rowData.stateCode || "",
      countryCode: rowData.countryCode || "",
      entityType: rowData.entityType || "",
      entityGroupCode: rowData.entityGroupCode || "",
      deleted: rowData.deleted || "",
      logoPath: rowData.logoPath || "",
      headerImagePath: rowData.headerImagePath || "",
      configCountryCode: rowData.configCountryCode || "",
      halfDayAllowed: rowData.halfDayAllowed || false,
      currencyCode: rowData.currencyCode || "",
      webSite: rowData.webSite || "",
      createdUserCode: rowData.createdUserCode || "",
      creditLimit: rowData.creditLimit || 0,
      creditDays: rowData.creditDays || 0
    });
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setIsEditing(false);
    setSelectedRowIndex(null);
  };


  const handleSaveForm = async () => {
    try {
      const token = localStorage.getItem('AuthorizationToken');
      const userId = localStorage.getItem('userId');
      const url = isEditing
        ? `${local_url}/api/Company/SaveCompany`
        : `${local_url}/api/Company/CreateEdit`;

      // Construct the payload manually
      const requestBody = {
        entityCode: formData.entityCode || "",
        entityName: formData.entityName || "",
        regAddress1: formData.regAddress1 || "",
        regAddress2: formData.regAddress2 || "",
        regAddress3: formData.regAddress3 || "",
        pinCode: formData.pinCode || "",
        placeCode: formData.placeCode || "", // Send placeCode (ID)
        cityCode: formData.cityCode || "",   // Send cityCode (ID)
        stateCode: formData.stateCode || "", // Send stateCode (ID)
        countryCode: formData.countryCode || "", // Send countryCode (ID)
        entityType: formData.entityType || "",
        entityGroupCode: formData.entityGroupCode || "",
        deleted: formData.deleted || "", // Default value if not provided
        logoPath: formData.logoPath || "", // Default value if not provided
        headerImagePath: formData.headerImagePath || "", // Default value if not provided
        configCountryCode: formData.configCountryCode || "", // Default value if not provided
        createdUserCode: userId || "", // Use userId from localStorage
        halfDayAllowed: formData.halfDayAllowed || false, // If applicable, default to false
        webSite: formData.webSite || "",// Default value if not provided
        currencyCode: formData.currencyCode || "",
        creditLimit: parseFloat(formData.creditLimit) || 0,
        creditDays: parseInt(formData.creditDays) || 0
      };

      // Send the request with individually specified properties
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      await fetchLedgerData();  // Fetch the updated data
      handleCloseForm();  // Close the form
    } catch (error) {
      setError("Failed to save company data. Please try again later.");
      console.error("API Error:", error);
    }
  };



  const handleDropdownChange = (event) => {
    setDropdownValue(event.target.value);
  };

  const IconLabelButtons = ({ onEdit, item }) => (
    <>
      {/* <Button
        variant="outlined"
        size="small"
        onClick={onEdit}
        style={{ marginRight: '8px' }}
      >
        Edit
      </Button> */}
      <Button
        variant="outlined"
        size="small"
        onClick={() => navigate('/branch-detail', {
          state: {
            companyName: item.entityName,
            companyCode: item.entityCode,
            // You can add more company details here if needed
          }
        })}
      >
        Branches
      </Button>
    </>
  );


  return (
    <div className="reports-root">
      <Header />
      <div className="reports-container">
        <div className="reports-header">
          <h1 className="reports-title">Company List</h1>
          <div className="dropdown-and-button">
            {/* <FormControl variant="outlined" style={{ minWidth: 120 }}>
              <InputLabel>Type</InputLabel>
              <Select value={dropdownValue} onChange={handleDropdownChange} label="Type">
                <MenuItem value="CUST">Customer</MenuItem>
                <MenuItem value="OWN">Group Company</MenuItem>
              </Select>
            </FormControl> */}
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={handleOpenForm}
              style={{ marginLeft: '10px' }}
            >
              Add Company
            </Button>
          </div>
        </div>

        {error && (
          <div className="reports-error">
            <span className="reports-error-text">{error}</span>
          </div>
        )}

        <div className="reports-table-wrapper">
          <div className="reports-table-container">
            <table className="reports-table">
              <thead>
                <tr>
                  <th style={{ width: '50px' }}>S.No</th>
                  <th>Company Code</th>
                  <th>Company Name</th>
                  <th>Reg Address 1</th>
                  <th>Reg Address 2</th>
                  <th>Reg Address 3</th>
                  <th>Pin Code</th>
                  <th>Place Code</th>
                  <th>City Code</th>
                  <th>State Code</th>
                  <th>Country Code</th>
                  <th>Company Type</th>
                  <th>Company Group Code</th>
                  <th>Credit Limit</th>
                  <th>Credit Days</th>
                  <th className="sticky-column">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="16" className="reports-loading">
                      <CircularProgress size={40} />
                    </td>
                  </tr>
                ) : ledgerData.length > 0 ? (
                  ledgerData.map((item, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: 'center' }}>{index + 1}</td>
                      <td>{item.entityCode || "-"}</td>
                      <td>{item.entityName || "-"}</td>
                      <td>{item.regAddress1 || "-"}</td>
                      <td>{item.regAddress2 || "-"}</td>
                      <td>{item.regAddress3 || "-"}</td>
                      <td>{item.pinCode || "-"}</td>
                      <td>{item.placeCode || "-"}</td>
                      <td>{item.cityCode || "-"}</td>
                      <td>{item.stateCode || "-"}</td>
                      <td>{item.countryCode || "-"}</td>
                      <td>{item.entityType || "-"}</td>
                      <td>{item.entityGroupCode || "-"}</td>
                      <td style={{ textAlign: 'right' }}>{item.creditLimit ? item.creditLimit.toLocaleString() : "0"}</td>
                      <td style={{ textAlign: 'center' }}>{item.creditDays || "0"}</td>

                      <td className="sticky-column reports-actions">
                        <IconLabelButtons onEdit={() => handleEdit(item, index)} item={item} />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="16" className="reports-no-data">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <Dialog open={openForm} onClose={handleCloseForm} maxWidth="md" fullWidth>
          <DialogTitle>{isEditing ? 'Edit Company' : 'Add New Company'}</DialogTitle>
          <DialogContent>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', padding: '16px' }}>
              <TextField
                label="Company Code"
                variant="outlined"
                name="entityCode"
                value={formData.entityCode}
                onChange={handleFormChange}
                fullWidth
              />
              <TextField
                label="Company Name"
                variant="outlined"
                name="entityName"
                value={formData.entityName}
                onChange={handleFormChange}
                fullWidth
              />
              <TextField
                label="Reg Address 1"
                variant="outlined"
                name="regAddress1"
                value={formData.regAddress1}
                onChange={handleFormChange}
                fullWidth
              />
              <TextField
                label="Reg Address 2"
                variant="outlined"
                name="regAddress2"
                value={formData.regAddress2}
                onChange={handleFormChange}
                fullWidth
              />
              <TextField
                label="Reg Address 3"
                variant="outlined"
                name="regAddress3"
                value={formData.regAddress3}
                onChange={handleFormChange}
                fullWidth
              />
              <TextField
                label="Pincode"
                variant="outlined"
                name="pinCode"
                value={formData.pinCode}
                onChange={handlePincodeChange}
                fullWidth
              />
              {loadingPlaces ? (
                <CircularProgress />
              ) : (
                <FormControl fullWidth variant="outlined">
                  <InputLabel>Place</InputLabel>
                  <Select
                    value={formData.placeCode}
                    onChange={handlePlaceSelect}
                    label="Place"
                  >
                    {places.map((place) => (
                      <MenuItem key={place.placeId} value={place.placeId}>
                        {place.placeName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              <TextField
                label="City"
                variant="outlined"
                name="cityName"
                value={formData.cityName || ""}  // Display the city name
                onChange={handleFormChange}      // Optional, if you want to allow editing, otherwise remove
                fullWidth
                disabled  // Disable because this is a display-only field
              />



              <TextField
                label="State"
                variant="outlined"
                name="stateName"
                value={formData.stateName || ""}
                onChange={handleFormChange}
                fullWidth
                disabled  // Disable because this is a display-only field
              />

              {/* The cityCode and stateCode will not be displayed, they will be sent in the request */}
              {/* <TextField
        label="City Code"
        variant="outlined"
        name="cityCode"
        value={formData.cityCode || ""}
        onChange={handleFormChange}
        fullWidth
        disabled  // Disable to prevent editing
      />

      <TextField
        label="State Code"
        variant="outlined"
        name="stateCode"
        value={formData.stateCode || ""}
        onChange={handleFormChange}
        fullWidth
        disabled  // Disable to prevent editing
      /> */}

              <TextField
                label="Country Code"
                variant="outlined"
                name="countryCode"
                value={formData.countryCode}
                onChange={handleFormChange}
                fullWidth
                disabled
              />

              <FormControl fullWidth variant="outlined">
                <InputLabel>Company Type</InputLabel>
                <Select
                  value={formData.entityType}
                  onChange={(e) => handleFormChange({ target: { name: "entityType", value: e.target.value } })}
                  label="Company Type"
                  name="entityType"
                >
                  <MenuItem value="BANK">Bank</MenuItem>
                  <MenuItem value="COMP">Other</MenuItem>
                  <MenuItem value="VEND">Vender</MenuItem>
                </Select>
              </FormControl>
              {/* 
              <TextField
                label="Comapny Group Code"
                variant="outlined"
                name="entityGroupCode"
                value={formData.entityGroupCode}
                onChange={handleFormChange}
                fullWidth
              /> */}
              {/* <TextField
                label="Website"
                variant="outlined"
                name="webSite"
                value={formData.webSite}
                onChange={handleFormChange}
                fullWidth
              /> */}
              {/* <TextField
                label="Currency Code"
                variant="outlined"
                name="currencyCode"
                value={formData.currencyCode}
                onChange={handleFormChange}
                fullWidth */}
              {/* /> */}
              {/* <FormControl fullWidth variant="outlined">
                <InputLabel>Half Day Allowed</InputLabel>
                <Select
                  value={formData.halfDayAllowed}
                  onChange={handleFormChange}
                  label="Half Day Allowed"
                  name="halfDayAllowed"
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </Select>
              </FormControl> */}
              <TextField
                label="Credit Limit"
                variant="outlined"
                name="creditLimit"
                type="number"
                value={formData.creditLimit}
                onChange={handleFormChange}
                fullWidth
                inputProps={{ min: 0, step: "0.01" }}
              />
              <TextField
                label="Credit Days"
                variant="outlined"
                name="creditDays"
                type="number"
                value={formData.creditDays}
                onChange={handleFormChange}
                fullWidth
                inputProps={{ min: 0, step: 1 }}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseForm} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSaveForm} color="primary" variant="contained">
              {isEditing ? 'Update' : 'Save'}
            </Button>
          </DialogActions>
        </Dialog>

        <style jsx>{`
            .reports-root {
              min-height: 100vh;
              background-color: #f5f7fa;
            }
  
            .reports-container {
              padding: 1rem;
              max-width: 1440px;
              margin: 0 auto;
            }
  
            .reports-header {
              display: flex;
              justify-content: space-around;
              align-items: center;
              margin-bottom: 2rem;
            }
  
            .reports-title {
              font-size: 1.75rem;
              font-weight: 600;
              color: #1a1a1a;
              margin: 0;
            }
  
            .dropdown-and-button {
              display: flex;
              align-items: center;
            }
  
            .reports-error {
              background-color: #fee2e2;
              border: 1px solid #ef4444;
              border-radius: 8px;
              padding: 1rem;
              margin-bottom: 1.5rem;
            }
  
            .reports-error-text {
              color: #dc2626;
              font-size: 0.875rem;
              font-weight: 500;
            }
  
            .reports-table-wrapper {
              background-color: white;
              border-radius: 12px;
              box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
                          0 2px 4px -1px rgba(0, 0, 0, 0.06);
              overflow: hidden;
            }
  
            .reports-table-container {
              overflow-x: auto;
              position: relative;
            }
  
            .reports-table {
              width: 100%;
              border-collapse: separate;
              border-spacing: 0;
              font-size: 0.875rem;
            }
  
            .reports-table th {
              background-color: #f8f9fa;
              color: #4b5563;
              font-weight: 600;
              text-align: left;
              padding: 1rem;
              border-bottom: 2px solid #e5e7eb;
              white-space: nowrap;
            }
  
            .reports-table td {
              padding: 1rem;
              border-bottom: 1px solid #e5e7eb;
              color: #374151;
            }
  
            .reports-table tbody tr:hover {
              background-color: #f9fafb;
            }
  
            .sticky-column {
              position: sticky !important;
              right: 0;
              background-color: white !important;
              z-index: 20;
              box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);
            }
  
            .reports-table tbody tr:hover .sticky-column {
              background-color: #f9fafb !important;
            }
  
            .reports-table th.sticky-column {
              background-color: #f8f9fa !important;
              z-index: 21;
            }
  
            .reports-actions {
              white-space: nowrap;
              text-align: center;
              min-width: 100px;
              padding: 0.5rem !important;
            }
  
            .reports-loading {
              text-align: center;
              padding: 3rem !important;
          }

          .reports-no-data {
            text-align: center;
            color: #6b7280;
            font-style: italic;
            padding: 2rem !important;
          }

          .form-row {
            display: flex;
            gap: 1rem;
            margin-bottom: 1rem;
          }

          .form-row .MuiTextField-root {
            flex: 1;
          }

          @media (max-width: 1024px) {
            .reports-container {
              padding: 0.5rem;
            }

            .reports-header {
              flex-direction: column;
              gap: 1rem;
            }

            .reports-title {
              font-size: 1.5rem;
              text-align: center;
            }

            .form-row {
              flex-direction: column;
              gap: 0;
            }
          }

          @media (max-width: 768px) {
            .reports-table-container {
              font-size: 0.75rem;
            }

            .reports-table th,
            .reports-table td {
              padding: 0.75rem;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default CompanyList;
